import { fontSizes, colors } from '../../../../Components/consts'
import { styled } from '@mui/system'

type ColProps = {
  side?: 'left' | 'right'
}

export const BoxscoreStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: theme.spacing(4),
}))

export const PlayerCardStyle = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: side === 'left' ? 'flex-end' : 'flex-start',
  '& a': {
    display: 'flex',
    textDecoration: 'none',
    '& .profileImgCon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
      '& > div': {
        '& img': {
          height: 50,
          borderRadius: '50%',
          margin: theme.spacing(1),
          [theme.breakpoints.down('sm')]: {
            height: 35,
          },
        },
      },
    },
  },
  '& .unleashedCon': {
    display: 'flex',
    '& .unleashedProfileImgCon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
      '& > div': {
        '& img': {
          height: 50,
          borderRadius: '50%',
          margin: theme.spacing(1),
          [theme.breakpoints.down('sm')]: {
            height: 35,
          },
        },
      },
    },
  },
}))

export const PlayerInfoCon = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: side === 'left' ? 'flex-end' : 'flex-start',
  margin: theme.spacing(2, 0),
  '& .playerTitleContainer': {
    display: 'flex',
    justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
    alignItems: 'center',
    margin: theme.spacing(0.35, 0),
  },
  '& h1': {
    fontWeight: 'bold',
    fontSize: fontSizes.large,
    marginTop: 0,
    marginBottom: 2,
    color: colors.gray.gray40,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 800,
      fontSize: 14,
    },
  },
  '& h3': {
    fontWeight: 'bold',
    fontSize: fontSizes.medium,
    margin: '0 5px 0',
    color: colors.gray.gray40,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 11,
    },
  },
}))

export const PlayerProfileCon = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  '& > div': {
    '& img': {
      height: 50,
      borderRadius: '50%',
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        height: 35,
      },
    },
  },
}))

export const ASRostersCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  '& .section': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    margin: theme.spacing(2, 0),
  },
  '& .subHeader': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(0, 0, 0.25),
    '& p': {
      marginLeft: 2,
      fontSize: fontSizes.small,
      color: colors.gray.gray40,
    },
  },
}))

export const TeamColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
  '& .teamImg': {
    height: 100,
    width: 100,
    margin: theme.spacing(1, 3),
    [theme.breakpoints.between('sm', 'md')]: {
      height: 75,
      width: 75,
      margin: theme.spacing(1, 2),
    },
    [theme.breakpoints.down('sm')]: {
      height: 65,
      width: 65,
      margin: theme.spacing(1),
    },
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '90%',
  },
}))

export const TeamImageCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  width: '100%',
  '& .teamImg': {
    height: 150,
    width: 150,
    margin: theme.spacing(1, 3),
    [theme.breakpoints.between('sm', 'md')]: {
      height: 100,
      width: 100,
      margin: theme.spacing(1, 2),
    },
    [theme.breakpoints.down('sm')]: {
      height: 85,
      width: 85,
      margin: theme.spacing(1),
    },
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '90%',
  },
}))

export const CoachColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 2),
  minWidth: 400,
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
    minWidth: '70%',
  },
}))

export const RosterColumn = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: side === 'left' ? 'flex-end' : 'flex-start',
  margin: theme.spacing(0, 7),
  minWidth: 400,
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 3),
    minWidth: '48%',
  },
}))

export const SecondaryRow = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  '& > div': {
    '& img': {
      height: 25,
      width: 25,
      margin: theme.spacing(0, 0.5),
      [theme.breakpoints.down('sm')]: {
        height: 15,
        width: 15,
      },
    },
  },
  '& .accolade': {
    fontSize: '1rem',
    color: colors.gray.gray40,
    margin: theme.spacing(0, 1, 0.25),
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 12,
    },
  },
  '& .positionText': {
    fontSize: '0.9rem',
    color: colors.gray.gray40,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 11,
    },
  },
}))

export const PlayerStyleCon = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  '& img': {
    height: 25,
    width: 25,
    margin: theme.spacing(0, 0.5),
    [theme.breakpoints.down('sm')]: {
      height: 18,
      width: 18,
    },
  },
}))

export const PlayerNameYearsCon = styled('div')<ColProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: side === 'left' ? 'flex-end' : 'flex-start',
  margin: theme.spacing(1, 0.5),
  '& h3': {
    fontWeight: 'bold',
    fontSize: fontSizes.medium,
    margin: '0 5px 0',
    color: colors.gray.gray40,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: 11,
    },
  },
  '& p': {
    fontSize: fontSizes.small,
    margin: '0 5px 0',
    color: colors.gray.gray40,
    [theme.breakpoints.down('md')]: {
      fontWeight: 500,
      fontSize: 10,
    },
  },
}))
